// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"762":"646a7730","977":"b7b9f2d0"}[chunkId] + ".chunk.css";
};